import { PrizmDay, PrizmTime } from '@prizm-ui/components';

export enum EDatePattern {
  MONTH_YEAR = 'MM.yyyy',
  DATE = 'dd.MM.yyyy',
  DATE_TIME_WITHOUT_SECONDS = 'dd.MM.yyyy HH:mm',
  DATE_TIME = 'dd.MM.yyyy HH:mm:ss',
  YEAR_MONTH_DAY = 'yyyy-MM-dd',
  DD_MM_YYYY = 'dd-MM-yyyy',
  DATE_TIME_ISO_MARKED_TIMEZONE = `yyyy-MM-dd'T'HH:mm:ss`,
  YYYY_MM_DD = 'yyyy/MM/dd',
  MMMM_YYYY = 'MMMM YYYY',
  DATE_TIME_ISO_PATTERN = 'yyyy-MM-ddTHH:mm:ss',
  DATE_TIME_FOR_TRACKER = 'YYYY-MM-DD HH:mm:ss',
  DATE_TIME_FOR_TRACKER_NOT_SIMPLE = 'yyyy-MM-dd HH:mm:ss',
  TUI_YMD = 'YMD',
}

export enum EMomentPattern {
  YYYY_MM_DD = 'YYYY-MM-DD',
  DATE_TIME_ISO = 'YYYY-MM-DDTHH:mm:ss',
}

export enum ETimezone {
  UTC = '+00:00',
  MSK = '+03:00',
  AQT = '+05:00',
  NVS = '+07:00',
  IRK = '+08:00',
  YAK = '+09:00',
}

export type SmaPrizmDateTime = [PrizmDay, PrizmTime | undefined];

export const STORED_TIMEZONE = 'storedTimezone';

export interface ITimeZone {
  time_diff: string;
  string: string;
  value: string;
}

export interface ICurrentTimeTZ {
  current_time: string;
  picked_time_zone: ITimeZone;
}

// Не менять формат, названия и ' ' оставлять всегда
// 'UTC ' - оставлять
// если менять,изменить фильтры в ДО
export const timezoneSelectItems = [
  'UTC +00:00',
  'Europe/Moscow +03:00',
  'Asia/Aqtau +05:00',
  'Asia/Yekaterinburg +05:00',
  'Asia/Novosibirsk +07:00',
  'Asia/Krasnoyarsk +07:00',
  'Asia/Irkutsk +08:00',
  'Asia/Yakutsk +09:00',
];

export const TIME_ZONES: ITimeZone[] = [
  {
    value: 'Etc/GMT',
    string: '+00:00 UTC',
    time_diff: ETimezone.UTC,
  },
  {
    value: 'Europe/Moscow',
    string: '+03:00 Москва',
    time_diff: ETimezone.MSK,
  },
  {
    value: 'Asia/Aqtau',
    string: '+05:00 Тюмень',
    time_diff: ETimezone.AQT,
  },
  {
    value: 'Asia/Novosibirsk',
    string: '+07:00 Томск',
    time_diff: ETimezone.NVS,
  },
  {
    value: 'Asia/Irkutsk',
    string: '+08:00 Иркутск',
    time_diff: ETimezone.IRK,
  },
  {
    value: 'Asia/Yakutsk',
    string: '+09:00 Якутск',
    time_diff: ETimezone.YAK,
  },
];
